










import Vue from 'vue';
import HotelItem from '@/components/HotelItem.vue';

export default Vue.extend({
  name: 'HoteltList',
  components: {
    HotelItem,
  },
  props: {
    hotels: Array,
  },
});
